<!-- 任务分配 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add">新增</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row.id)"></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button :loading="delLoading" type="primary" size="mini" @click="subDelete(scope.row.id)">确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>

            <!-- <el-button slot="reference" type="danger" icon="el-icon-delete" size="mini"/> -->
          </el-popover>
        </template>
        <template #icon="row">
          <svg-icon :icon-class="row.icon"/>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
  import '@/components/EditDataTable';
  import DynamicSearch from '@/components/DynamicSearch';
  import DataTableMixin from '@/mixins/DataTableMixin';
  import '@/components/dynamic-form';
  import { del } from '@/api/bill/taskAssignment/index.js'

  export default {
    name: 'Achievement',
    directives: {},
    filters: {},
    mixins: [DataTableMixin],
    components: {
      DynamicSearch,
      // eForm,
    },
    data() {
      return {
        delLoading: false,
        supThis: this,
        isAdd: false,
        tableHead: [
          {
            prop: 'code',
            label: '单据编号',
          },
          {
            prop: 'projectId',
            label: '项目号',
            // editRender: { type: 'number', name: 'ElInputNumber' },
            query: {
              type: 'input'
            }
          },
          {
            prop: 'allocationTime',
            label: '分配日期',
          },
          {
            prop: 'bsPerson.name',
            label: '任务接受人',
          },
          {
            prop: 'bsProjectNode.name',
            label: '项目节点',
          },
          {
            prop: 'bsMilestoneNode.name',
            label: '里程碑节点',
          },
          {
            prop: 'completeState',
            label: '完成',
          },
          {
            prop: 'remark',
            label: '备注'
          }

        ],
        treeData: [],
        treeProps: {
          children: 'children',
          label: 'name'
        },
        formData: {
          isAdd: true,
          id: ""
        }
      };
    },
    computed: {},
    watch: {},
    created() {
      // 列表数据初始化
      this.$nextTick(() => {
        this.dataTableInit();
      });
    },
    methods: {
      dataTableBeforeInit() {
        this._url = '/bizTaskAllocation/findList';
        const params = {current: this.page, size: this.offset};
        this._params = Object.assign(params, this._query);
        return true
      },
      handleDeletes(rows) {
        rows.forEach(element => {
          this.subDelete(element.id)
        });
      },
      subDelete(id) {
        this.delLoading = true;
        console.log(id);
        del(id).then(res => {
          this.delLoading = false;
          this.$refs[id].doClose();
          this.dleTableChangePage();
          this.dataTableInit();
          this.$notify({
            title: '删除成功',
            type: 'success',
            duration: 2500
          })
        }).catch(err => {
          this.delLoading = false;
          this.$refs[id].doClose();
          console.log(err)
        })
      },
      edit(data) {
        console.log(data);
        this.formData.id = data;
        this.formData.isAdd = false;
        this.$router.push({path: 'taskAssignment/form', query: this.formData});
        // queryById(data).then(res => {
        //   if (res.code === 200) {
        //     this.formData.data = res.data;
        //     console.log(this.formData);
        //     this.formData.isAdd = false;
        //     this.$router.push({path: 'taskAssignment/form',query: this.formData})
        //   }
        // });
      },
      add() {
        this.formData.isAdd = true;
        this.$router.push({path: 'taskAssignment/form',query: this.formData})
      }
    }
  };
</script>

<style scoped>
  .btn {
    border: none;
    padding: 0;
  }
</style>
